import React from 'react';
import { useLocation } from 'react-router-dom';
import Helmet from 'react-helmet';
import manifest from '../i18n/articleManifest.json';
import { articleLanguages, isArticleLanguage } from '../i18n/articleLanguages';

export function findArticle(pathname: string) {
  const path = pathname.toLowerCase().replace(/\/+$/, '');
  const parts = path.split('/');
  const language = isArticleLanguage(parts[1]) ? parts[1] : undefined;
  const article = manifest.find(entry => entry.path === (language ? '/' + parts.slice(2).join('/') : path));
  return { article, language };
}
export function ArticleHead() {
  const { pathname } = useLocation();
  const { article, language } = findArticle(pathname);
  if (!article || !language) return null;
  const current = language || article.sourceLanguage;
  const url = (code: string) => 'https://www.play-cloud.com' + (code === article.sourceLanguage ? '' : '/' + code) + article.path;
  return <Helmet>
    <html lang={current} dir={['he', 'ar'].includes(current) ? 'rtl' : 'ltr'} />
    <link rel="canonical" href={url(current)} />
    {articleLanguages.map(code => <link key={code} rel="alternate" hrefLang={code === 'zh' ? 'zh-Hans' : code} href={url(code)} />)}
    <link rel="alternate" hrefLang="x-default" href={'https://www.play-cloud.com' + article.path} />
  </Helmet>;
}
export function ArticleLanguageLinks() {
  return null;
}
